


/*
To use ipmort scrller and call

   import scroller from '../scroller';
    scroller.scroller();


*/



module.exports = {
    scroller: function () {
        $(window).on("scroll", function() {
            var scroll = $(window).scrollTop();
            var speed = 0.4;
            const scrollerItem = $('[data-control="scroller"]');

            
            scrollerItem.each(function(){
                var $this = $(this);
                var $parent = $this.parent();
                var topOffset = $parent.offset().top;
                var height = $parent.outerHeight(true);
                var parallaxSize = (scroll - topOffset) * speed;
                
                // prevent parallax when scroll down
                 if(scroll > topOffset + height) {
                    return;
                }
                $this.css({ 
                    'transform': scroll >= topOffset ? ('translateY(' + parallaxSize + 'px)' ) : ''
                });
            }); 
        });  
    }
}




/*
$(window).on("scroll", function() {
	var scroll = $(window).scrollTop();
    var speed = 0.4;
    
	$('.scroller').each(function(){
		var $this = $(this);
        var $parent = $this.parent();
        var topOffset = $parent.offset().top;
        var bottomOffset = $parent.offset().bottom;
        var height = $parent.outerHeight(true);
        var parallaxSize = (scroll - topOffset) * speed;
        var secondParallaxSize = (scroll - topOffset + height) * speed;
        
        // prevent parallax when scroll down
         if(scroll > topOffset + height) {
            console.log('scroll', parallaxSize);
            return;
        }
        console.log('scrollno', secondParallaxSize);
        $this.css({ 
            'transform': scroll >= topOffset ? ('translateY(' + parallaxSize + 'px)' ) : ''
        });
	}); 
});  
*/